var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.$t("account.home.title")))]),_c('p',{staticClass:"font-weight-thin"},[_vm._v(_vm._s(_vm.$t("account.home.subTitle")))]),_c('v-container',{staticClass:"pa-0",attrs:{"fluid":"","grid-list-lg":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }